import React, { useState, useEffect } from "react";
import { BiUpArrow, BiDownArrow, BiSearch } from "react-icons/bi";
import DropShadow from "../UIResuableComponents/Dropshadow";
import {
  RiFilter2Fill,
  RiArrowDropLeftLine,
  RiArrowDropRightLine,
} from "react-icons/ri";
// component to create frame of leafplud project
const Base = (props) => {

  // ROW and Total state for setting page number
  const [rowPerPage,setRowPerPage] = useState('NA')
  const [outOfTotal,setOutOfTotal] = useState('NA')
  const [openFilter, setOpenFilter] = useState(false);
  const onSelectMoreQuality = () => {
    props.setProducType("select", "addmore");
    props.onChangeDropShadowHandler("Create");
  };
  const onSelectCreate = () => {
    props.secondCreateBtn && props.setProducType("text", "normalcreate");
    props.onChangeDropShadowHandler("Create");
  };
  const onSelectAdjust = () => {
    props.setDataForAdjust("Adjust");
    props.onChangeDropShadowHandler("Update");
  };
  const onOpenFilter = () => {
    setOpenFilter((prevState) => !prevState);
  };

  
  

  

// Variables for storing content of page number items
  let totalLength = props.generalList.length;
  let content1 = <div className="mr-4">rows per page: {rowPerPage}</div>
   let content2 = <div className="mr-4">1-{outOfTotal} of {totalLength}</div>
   
   // For page Number to set
   useEffect(() => {
    if(totalLength >=10){
      setRowPerPage('10')
      setOutOfTotal('10')
    }
    else if(totalLength < 10){
      setRowPerPage(totalLength)
      setOutOfTotal(totalLength)
    }
  }, [totalLength]);

  return (
    <div className="mt-[3rem] left-[1%] px-4  top-[10%] z-0 w-full">
      <div className="flex flex-col justify-between mb-8">
        <h1 className="font-bold border-b-[1px] border-textgreen pb-0.5 mb-4">
          {props.OptionName} List
        </h1>
        <div className="flex flex-col lg:flex-row w-full justify-between lg:items-center">
          <div className="relative font-bold flex w-full lg:w-[30%] md:flex-row mb-2">
            <button
              onClick={onOpenFilter}
              className="bg-bgwhite hover:scale-95 active:scale-100  py-1.5 text-textgreen border-[1px] border-textgreen rounded px-3 text-xs font-medium flex items-center   md:mr-2"
            >
              <span className="text-lg ">
                <RiFilter2Fill />
              </span>
              <span className="ml-1">Filter</span>
            </button>
            <div className="flex bg-bgdarkgrey mt-1 rounded ml-2  w-full ">
              <span className="px-2 flex text-textgreen justify-center items-center">
                <BiSearch />
              </span>
              <input
                className=" py-1.5 px-3 text-[0.5rem]  w-full bg-bgdarkgrey placeholder:text-textgreen sm:text-xs rounded"
                type="text"
                placeholder={`Search ${props.OptionName}`}
              />
            </div>
            {openFilter && (
              <>
                {" "}
                <div className="absolute bottom-[-347%] w-[50%] z-50 rounded reusebox-shadow  bg-bgwhite">
                  <ul className="text-xs w-full h-full py-3 px-3">
                    <li className="cursor-pointer mb-1 pb-1 border-b-[1px] border-[rgba(0,0,0,0.1)]">
                      Sort By{" "}
                    </li>
                    <li className="cursor-pointer mb-1 pb-1 border-b-[1px] border-[rgba(0,0,0,0.1)]">
                      Sort By{" "}
                    </li>
                    <li className="cursor-pointer mb-1 pb-1 ">Sort By </li>
                  </ul>
                </div>
                <DropShadow
                  onDropDownToggle={onOpenFilter}
                  dropDownStyle={"!bg-trans"}
                />
              </>
            )}
          </div>

          {/* sort desc asc */}
          <div className="flex lg:justify-between items-start md:items-center mt-2 flex-row ">
            <div className="mr-6 text-btnbgcolor flex flex-col mb-2 justify-center">
              <span className="text-xs cursor-pointer">
                <BiUpArrow />
              </span>
              <span className="text-xs cursor-pointer">
                <BiDownArrow />
              </span>
            </div>
            {props.needAdjust && (
              <button
                onClick={() => onSelectAdjust("Adjust")}
                className="bg-btnbgcolor mb-2 hover:scale-95 active:scale-100 mr-2  py-1.5 text-bgwhite rounded px-3 sm:px-8 text-[0.5rem] md:text-xs font-medium"
              >
                Adjust
              </button>
            )}
            {props.secondCreateBtn && (
              <button
                onClick={() => onSelectMoreQuality("AddMore")}
                className="bg-btnbgcolor mb-2 hover:scale-95 active:scale-100 mr-2  py-1.5 text-bgwhite rounded px-3 sm:px-8 text-[0.5rem] md:text-xs font-medium"
              >
                Add More Quality
              </button>
            )}
            <button
              onClick={() => onSelectCreate()}
              className="bg-btnbgcolor mb-2 hover:scale-95 active:scale-100  py-1.5 text-bgwhite rounded px-8 text-[0.5rem] md:text-xs font-medium"
            >
              CREATE
            </button>
          </div>
        </div>
      </div>
      {/* pagination  */}
      <div
        className={`bg-bgdarkgrey custom-scroll-for-nav  ${
          props.generalList
            ? "overflow-y-scroll h-[25rem]"
            : "overflow-visible h-auto"
        } rounded-lg`}
      >
        {props.children}
      </div>
      <div className="flex justify-end rounded-lg pr-4 mt-4 py-2 bg-bgdarkgrey text-[0.6rem] sm:text-xs text-textgreen">
        {content1}
        {content2}       
        <div className="flex items-center text-xl ">
          <span className="cursor-pointer rounded-lg delay-150 hover:bg-textgreen  hover:text-bgwhite">
            <RiArrowDropLeftLine />
          </span>
          <span className="cursor-pointer ml-1 rounded-lg  delay-150 hover:bg-textgreen  hover:text-bgwhite">
            <RiArrowDropRightLine />
          </span>
        </div>
      </div>
    </div>
  );
};
export default Base;
